import routes from '@/app/routing/routes';
import Route from '@/app/routing/Route';
import { ADMIN_ROLES, USER_ROLES } from '@/app/routing/auth-redirect';
import pages from '@/pages';
import Login from '@/pages/login';

const routerConfig = [
  {
    path: '/',
    component: pages.Login,
    exact: true,
    guestOnly: true,
  },
  {
    path: Object.values(routes.adminPanel),
    component: pages.AdminPanel,
    auth: true,
    roles: ADMIN_ROLES,
  },
  {
    path: routes.decedentInitiation,
    component: pages.DecedentInitiation,
    auth: true,
    roles: USER_ROLES,
  },
  {
    path: Object.values(routes.dashboard),
    component: pages.UserDashboard,
    auth: true,
    roles: USER_ROLES,
  },
  {
    path: routes.login,
    component: pages.Login,
    guestOnly: true,
  },
  {
    path: routes.setupAccount,
    component: pages.SetupAccount,
  },
  {
    path: routes.newPassword,
    component: pages.NewPassword,
    guestOnly: true,
  },
  {
    path: routes.resetPassword,
    component: pages.ResetPassword,
    guestOnly: true,
  },
  {
    path: routes.adminLogin,
    render: (props) => <Login {...props} isAdmin />,
    guestOnly: true,
  },
];

export { routerConfig, routes, Route };
